// src/services/educationLevelService.js
import axiosClient from "./axiosClient";

const route = "schoolClass";

// Get all education levels
export const getAllEducationLevels = async (params) => {
  try {
    const response = await axiosClient.get(`${route}/getAll`, {
      params,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// Create a new education level
export const createEducationLevel = async (educationLevelData) => {
  try {
    const response = await axiosClient.post(`${route}`, educationLevelData);
    return response;
  } catch (error) {
    throw error;
  }
};

// Update an existing education level
export const updateEducationLevel = async (educationLevelId, updateData) => {
  try {
    const response = await axiosClient.put(
      `${route}/${educationLevelId}`,
      updateData
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// Delete an education level
export const deleteEducationLevel = async (educationLevelId) => {
  try {
    const response = await axiosClient.delete(`${route}/${educationLevelId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

// Get a specific education level by ID
export const getEducationLevelById = async (educationLevelId) => {
  try {
    const response = await axiosClient.get(`${route}/${educationLevelId}`);
    return response;
  } catch (error) {
    throw error;
  }
};
export const getEducationLevelSubclass = async (educationLevelId) => {
  try {
    const response = await axiosClient.get(
      `${route}/subClasses/${educationLevelId}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};
